import { memo } from 'react';
import { GridCellParams } from '@mui/x-data-grid';
import clsx from 'clsx';
import { Root, Value, Bar } from './styles';

interface ProgressBarProps {
  value: number;
}

const ProgressBar = memo((props: ProgressBarProps) => {
  const { value } = props;
  const valueInPercent = value * 100;

  return (
    <Root>
      <Value>{`${valueInPercent.toLocaleString()} %`}</Value>
      <Bar
        className={clsx({
          normal: valueInPercent < 30,
          alert: valueInPercent >= 30 && valueInPercent <= 70,
          late: valueInPercent > 70,
        })}
        style={{ maxWidth: `${valueInPercent}%` }}
      />
    </Root>
  );
});

export function renderProgress(params: GridCellParams): JSX.Element {
  if (params.row.sipacId) {
    return <ProgressBar value={Number(params.value)} />;
  }
  return <></>;
}
